module.exports = __webpack_public_path__ + "static/media/proj2.95d35972.jpg";